document.addEventListener('DOMContentLoaded', async () => {
  // import('focus-visible').then((module) => module) // Not needed in this project

  // utilities

  import('utility/page-restore').then((module) => module.default.init())
  import('utility/prefetch').then((module) => module.default.init())
  import('utility/smooth-scroll').then((module) => module.default.init())
  import('utility/vertical-resize-check').then((module) => module.default.init())

  // blocks

  if (document.querySelector<HTMLElement>('.board-block')) {
    import('blocks/board-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.bullet-points-block')) {
    import('blocks/bullet-points-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.events-block')) {
    import('blocks/events-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.file-links-block')) {
    import('blocks/file-links-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.illustration-block')) {
    import('blocks/illustration-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.image-block')) {
    import('blocks/image-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.info-cards-block')) {
    import('blocks/info-cards-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.process-block')) {
    import('blocks/process-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.quotation-block')) {
    import('blocks/quotation-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.reviews-block')) {
    import('blocks/reviews-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.statistics-block')) {
    import('blocks/statistics-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.text-block')) {
    import('blocks/text-block').then((module) => module.default.init())
  }

  // components

  if (document.querySelector<HTMLElement>('.contact-page__form')) {
    import('components/contact').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.get-a-quote')) {
    import('components/get-a-quote').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header')) {
    import('components/navigation').then((navigationModule) => {
      navigationModule.default.init()
      import('components/loader').then((loaderModule) => {
        loaderModule.default.init()
      })
    })
  }

  if (document.querySelector<HTMLElement>('.input-file')) {
    import('components/input-file').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-group')) {
    import('components/input-group').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.picture')) {
    import('components/picture').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.staff')) {
    import('components/staff').then((module) => module.default.init())
  }

  // sections

  if (document.querySelector<HTMLElement>('.banner')) {
    import('sections/banner').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.footer')) {
    import('sections/footer').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.hero')) {
    import('sections/hero').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.newsletter')) {
    import('sections/newsletter').then((module) => module.default.init())
  }

  // dev helpers

  if (process.env.NODE_ENV !== 'production') {
    import('utility/keyboard-shortcuts').then((module) => {
      module.contentEditable.init()
      module.goToStyleguide.init()
    })
    import('utility/overlay-grid').then((module) => module.default.init())
  }

  // page load

  document.querySelector<HTMLElement>('.header').style.opacity = '0'
  document.querySelector<HTMLElement>('.main').style.opacity = '0'

  setTimeout(() => {
    document.querySelector<HTMLElement>('.body').classList.remove('noscript')
    document.querySelector<HTMLElement>('.body').classList.remove('preload')
  }, 123)
})
